












































































import {
  $,
  IResource,
  ObjectCollection,
} from 'simpli-web-sdk'
import {Component, Prop, Vue, Mixins} from 'vue-property-decorator'
import {Period} from '@/enums/Period'
import {ItrackCollection} from '@/helpers'
import DeliveryShipperRequest from '@/model/request/DeliveryShipperRequest'
import Responsavel from '@/model/resource/Responsavel'
import {MixinMember} from '@/components/mixins/MixinMember'
import * as Helper from '@/helpers'

@Component
export default class FilterDeliveryShipper extends Mixins(MixinMember) {
  Period = Period

  allResponsavel = ItrackCollection.allResponsavelEmbarcador

  @Prop({required: true}) value!: DeliveryShipperRequest

  async mounted( ) {
    await this.allResponsavel.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  get responsavelCollection() {
    const items = this.allResponsavel.items
      .map((item) => {
        if (item.$id) {
          return {
            $id: item.$id,
            $tag: `${Helper.cnpj(item.cnpj)} ${$.filter.truncate(item.$tag, 15)}`,
          }
        }
        return item
      })

    return new ObjectCollection(items)
  }

  get responsavelResource() {
    return this.allResponsavel.get(this.value.idResponsavel)
  }

  set responsavelResource(val: Responsavel | null) {
    this.value.nome = (val && val.$tag) && (val.razaoSocial || val.nomeFantasia) || null
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
